import { z } from "zod";

import { ExtractAtomicOperationFromDefinition } from "../../../atomic-operations/index.js";
import {
  CellReferencesParseError,
  PythonCellReferencesV2,
} from "../../../code/index.js";
import { CodeCellId } from "../../../idTypeBrands.js";
import { zFromRuntype } from "../../../zod/utils.js";
import { makeUpdateCellContentsOperation } from "../makeUpdateCellContentsOperation.js";

export interface CodeCellUpdatableFields {
  source: string;
  cellReferencesV2: PythonCellReferencesV2 | null;
  cellReferencesParseError: CellReferencesParseError | null;
}

const _UpdateCodeCellSafeFields: {
  [key in keyof CodeCellUpdatableFields]: "";
} = {
  source: "",
  cellReferencesV2: "",
  cellReferencesParseError: "",
};
export const UpdateCodeCellSafeFields = Object.keys(_UpdateCodeCellSafeFields);

export const UPDATE_CODE_CELL = makeUpdateCellContentsOperation<
  CodeCellUpdatableFields,
  CodeCellId
>()({
  type: "UPDATE_CODE_CELL",
  fields: {
    source: z.string(),
    cellReferencesV2: zFromRuntype(PythonCellReferencesV2).nullable(),
    cellReferencesParseError: zFromRuntype(CellReferencesParseError).nullable(),
  },
  entityName: "CodeCell",
  fieldName: "codeCellId",
});
export type UPDATE_CODE_CELL = ExtractAtomicOperationFromDefinition<
  typeof UPDATE_CODE_CELL
>;
